/**
 * RIG-625 — message protocol between a newly installed service worker and the
 * pages it may take over.
 *
 * Background. Overnight D4 (#800) switched the three PWAs from `autoUpdate`
 * to `prompt` mode: a new worker waits, and the page shows "A new version is
 * available. Reload". A page still running an OLD (autoUpdate) build has no
 * code to show that prompt, so after the first deploy that carries #800 the
 * new worker would wait forever and the page would keep the old build until
 * every tab was closed.
 *
 * The fix is a one-time takeover decided by the worker at install time:
 *
 *   1. The worker posts {@link SW_TAKEOVER_PING} to every window client.
 *   2. A page that can show the prompt answers {@link SW_TAKEOVER_REPLY}.
 *   3. If any page answers within {@link SW_TAKEOVER_WAIT_MS}, the worker
 *      stays waiting (prompt mode, as #800 intends).
 *   4. If nobody answers (old pages, or no pages at all), the worker calls
 *      `skipWaiting()`; the old page's autoUpdate client reloads once on the
 *      worker's `activated` event, exactly as it did before #800.
 *
 * Both sides import these constants, so the two halves cannot drift apart.
 */
/** Worker to page: "can you show the update prompt?" */
export const SW_TAKEOVER_PING = 'rr-sw:can-you-prompt';
/** Page to worker: "yes, I show the update prompt; keep waiting." */
export const SW_TAKEOVER_REPLY = 'rr-sw:i-can-prompt';
/**
 * How long the worker waits for an answer before taking over. Message
 * delivery to an open page is near-instant (it is an event, not a timer), so
 * one second is generous while still keeping the install short when there is
 * nobody to answer.
 */
export const SW_TAKEOVER_WAIT_MS = 1000;
/** File name of the worker-side script each app ships beside its `sw.js`. */
export const SW_TAKEOVER_SCRIPT = 'sw-takeover.js';
function hasType(data, type) {
    return (typeof data === 'object' &&
        data !== null &&
        'type' in data &&
        data.type === type);
}
export function isSwTakeoverPing(data) {
    return hasType(data, SW_TAKEOVER_PING);
}
export function isSwTakeoverReply(data) {
    return hasType(data, SW_TAKEOVER_REPLY);
}
//# sourceMappingURL=protocol.js.map